import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ControlContainer, FormControl, NgForm } from '@angular/forms';
import { ConfirmationDialogComponent } from '@app/components/platform/confirmation-dialog/confirmation-dialog.component';
import { getMappingTableColumnTypes } from '@app/modules/import/functions/get-mapping-table-column-types';
import { Column } from '@import/classes';
import { StepChange } from '@import/enums/step-change.enum';
import { ColumnType } from '@import/interfaces';
import { EmployeeHumiColumnService, EmployeeRowAndColumnService } from '@import/services';
import { AnalyticService } from '@app/services';
import { AnalyticEvents } from '@app/enums';

@Component({
    selector: 'app-mapping-table-section-column',
    templateUrl: './mapping-table-section-column.template.html',
    styleUrls: ['./mapping-table-section-column.style.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class MappingTableSectionColumn {
    @Input() sectionColumn: ColumnType;
    @Output() triggerValidation: EventEmitter<void> = new EventEmitter();
    @ViewChild('emptyModal', { static: true }) emptyModal: ConfirmationDialogComponent;
    @ViewChild('replacementModal', { static: true }) replacementModal: ConfirmationDialogComponent;

    // Used for dynamic modal copy
    selectionColumn: Column;
    previousHumiMapping: ColumnType;

    constructor(
        public importerService: EmployeeRowAndColumnService,
        private analytics: AnalyticService,
        private humiColumnService: EmployeeHumiColumnService
    ) {}

    async onColumnSelection(selectionColumn: Column | null, formControl: FormControl<Column | null>): Promise<void> {
        this.selectionColumn = selectionColumn;
        let emptyConfirmed = true;

        // Selected Column is has Empty Values, Show Empty Modal
        if (this.selectionColumn?.isEmpty()) {
            emptyConfirmed = await this.emptyModal.open();
            if (!emptyConfirmed) {
                // If confirmation is cancelled, reset
                formControl.setValue(this.sectionColumn.csvColumn, { emitEvent: false });
                this.selectionColumn = null;
                return;
            }
        }

        // Selected Column is Already Mapped,Show Replacement Modal
        this.previousHumiMapping = getMappingTableColumnTypes(this.humiColumnService.getMappingTables()).find(
            (humiColumn) => humiColumn.csvColumn === selectionColumn && selectionColumn !== null
        );
        if (this.previousHumiMapping && emptyConfirmed) {
            const replaceConfirmed = await this.replacementModal.open();
            // If confirmation is cancelled, reset
            if (!replaceConfirmed) {
                formControl.setValue(this.sectionColumn.csvColumn, { emitEvent: false });
                this.selectionColumn = null;
                return;
            }
        }

        if (this.selectionColumn) {
            // Unset Mapping on Humi Column if Selection has Previous Mapping
            if (this.previousHumiMapping) {
                this.previousHumiMapping.csvColumn = null;
            }

            // Set Mapping when selection exists
            this.sectionColumn.csvColumn = this.selectionColumn;
        } else {
            // Reset Mapping for current column when selection is NULLs
            this.sectionColumn.csvColumn = null;
        }

        this.importerService.setLastChange(StepChange.ColumnMapping);
        this.triggerValidation.emit();
        this.analytics.trackEvent(AnalyticEvents.ImporterStep2ColumnRemapped);
    }
}
